module.exports = __webpack_public_path__ + "static/shimza_0-d27a981c31639bb35cbd62ec6ac4db1e.jpg";